import type { HeaderSocialNetwork } from './header-types';

/** Scroll distance after which the top bar collapses and the header gets its floating shadow. */
export const HEADER_STUCK_OFFSET = 40;

export const HEADER_DRAWER_ID = 'header-drawer';

/** Brand names are not translated, so they live here instead of in the dictionary. */
export const SOCIAL_NETWORK_LABELS: Record<HeaderSocialNetwork, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  pinterest: 'Pinterest',
  tiktok: 'TikTok',
  twitter: 'X',
  youtube: 'YouTube',
};
